import {useQuoteContext} from "../../../contexts/QuoteContext";
import {Alert} from "antd";
import {Link} from "react-router-dom";
import React from "react";
import Configurator from "../../../pages/configurator";

const AlertOldRevision = () => {
    const quoteContext = useQuoteContext();
    const quote = quoteContext.quote;

    if ( !quote || quote?.displayRevisionId === quote?.effectiveRevisionId ) return <></>

    var latestUrl = "/configurator/" + encodeURI(quote?.quoteId);

    return <div style={{marginBottom: "1rem"}}>
        <Alert
            type="warning"
            showIcon
            message={<>This is an old revision. <Link to={latestUrl}>Return to latest.</Link></>}
            style={{marginBottom: "1rem"}}
        />
    </div>
}

export default AlertOldRevision;
